// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"6141f548","519":"16731e9f","618":"827ab820","738":"fc47b667","747":"0bdf2d1f"}[chunkId] + ".chunk.js";
};